import React, { useEffect } from 'react';
import Image from 'next/image';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';

type BannerProps = {
  width: number;
  height: number;
  imageUrl: string;
  eventInfo: string;
  linkFromBanner: string;
  backgroundColor?: string;
  bannerType: 'mobile' | 'desktop';
  className?: string;
  bannerName: string;
};

const Banner = ({
  width,
  height,
  imageUrl,
  linkFromBanner,
  backgroundColor,
  className,
  eventInfo,
  bannerType,
  bannerName,
}: BannerProps) => {
  const { sendEvent } = useClickStreamEvent();

  const sendClickEvent = () => {
    sendEvent({
      eventType: 'click',
      eventInfo,
      customDimentions: {
        cd1: bannerName,
      },
    });
  };

  useEffect(() => {
    sendEvent({
      eventType: 'display',
      eventInfo,
      customDimentions: {
        cd1: bannerName,
      },
    });
  }, []);

  return (
    <a
      href={linkFromBanner}
      target="_blank"
      className={`${className}`}
      rel="noopener"
      style={bannerType === 'mobile' ? { background: backgroundColor } : undefined}
      onClick={sendClickEvent}
    >
      <Image priority src={imageUrl} width={width} height={height} alt="" />
    </a>
  );
};

export default Banner;
